import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import InboxIcon from "@material-ui/icons/Inbox";
import MailIcon from "@material-ui/icons/Mail";
import Typography from "@material-ui/core/Typography";
import {BrowserRouter as Router, Link} from "react-router-dom";
import {getNavigationUrl} from "../navigation";
import React, {useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {useShoppingCart} from "../hooks/shoppingcart";
import Box from "@material-ui/core/Box";
import Icon from "@material-ui/core/Icon";
import {getContrastingColor} from "react-color/lib/helpers/color";
import {useTranslation} from "react-i18next";
import {useCheckout} from "../Providers/CheckoutProvider";
import {formatCurrency} from "../../../utils";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarPlaceholder: {
        marginBottom: props => props.disableGutters ? 0 : theme.spacing(2),
        height: '70px',
        flexShrink: 0,
        flexGrow: 0
    },
    noGrow: {
        flexGrow: 0,
    },
    grow: {
        flexGrow: 1
    },
    menuButton: {
        flexGrow: 0
    },
    cartItems: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '20px',
        height: '20px',
        borderRadius: '10px',
        color: theme.palette.getContrastText(theme.palette.secondary.main),
        backgroundColor: theme.palette.secondary.main,
        fontSize: '12px',
        lineHeight: '20px',
        textAlign: 'center'
    },
    mainMenu: {
        '& > .muiPaper-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            width: '260px'
        },
        '& .menu-active': {
            backgroundColor: 'rgba(0,0,0,0.05)',
        },
        '&.menu-active': {
            backgroundColor: 'rgba(0,0,0,0.05)',
        },
        '& .menu-item-with-children': {
            textTransform: 'uppercase',
            '& span': {
                fontWeight: 'bolder',
                fontSize: '1em'
            }
        }
    },
    logoContainer: {
        flexGrow: 1,
        flexShrink: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '70px',
        '& > a > img': {
            maxWidth: '100%',
            maxHeight: '50px'
        }
    },
    menuTopLevel: {
        color: 'rgba(102,102,102,0.85)',
        textTransform: 'uppercase',
        borderTop: '1px solid #ececec',
        '& span': {
            fontWeight: 700,
            fontSize: '1em'
        },
        '&.menu-active': {
            color: '#000'
        }
    },
    menuLevelOne: {
        paddingLeft: '20px',
    },
    menuLevelTwo: {
        paddingLeft: '30px',
        paddingBottom: 0,
        color: '#666',
        '& span': {}
    },
    appBarRoot: {
        backgroundColor: 'white',
        color: 'black',
    },
    freeShipping: {
        backgroundColor: theme.palette.primary.light,
        color: getContrastingColor(theme.palette.primary.light),
        textAlign: 'center',
        padding: theme.spacing(1),
        marginBottom: props => props.disableGutters ? 0 : theme.spacing(2)
    }
}));
export default (props) => {
    const classes = useStyles(props);
    const [menuOpen, setMenuOpen] = useState(false)
    const {items} = useShoppingCart();

    const freeShippingBar = parseInt(window.NTLF_CONFIG.portal.options['free-shipping-threshold']);
    const toolbarDisableGutters = freeShippingBar || props.disableGutters;

    return (
        <React.Fragment>
            <AppBar classes={{root: classes.appBarRoot}}>
                <Toolbar className={classes.toolbar} disableGutters={true}>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="primary"
                        aria-label="open drawer"
                        onClick={e => setMenuOpen(true)}
                    >
                        <MenuIcon/>
                    </IconButton>

                    <div className={classes.logoContainer}>
                        <LogoWithLink/>
                    </div>

                    <Box>
                        <ShoppingCart items={items}/>
                    </Box>
                </Toolbar>
            </AppBar>
            <ToolbarPlaceholder className={classes.toolbarPlaceholder}
                                disableGutters={toolbarDisableGutters}/>
            {!isNaN(freeShippingBar) &&
                <FreeShippingBar threshold={freeShippingBar}
                                 disableGutters={props.disableGutters}/>}
            <Menu menuOpen={menuOpen} onClose={e => setMenuOpen(false)}/>
        </React.Fragment>
    )
}

const LogoWithLink = (props) => {
    const classes = useStyles(props);
    if (window.NTLF_CONFIG.portal.uuid === '96f2fc05-bc01-11ed-9e7d-3cecef0df660') {
        return <a href='https://www.preusbilder.no'>
            <img className={classes.logo} src={window.LOGO_URL}/>
        </a>
    }

    return <Link to='/'>
        {window.LOGO_URL &&
            <img className={classes.logo} src={window.LOGO_URL}/>}
    </Link>
}

const ToolbarPlaceholder = (props) => {
    const classes = useStyles(props)
    return <Toolbar className={classes.toolbarPlaceholder}
                    disableGutters={props.disableGutters}/>
}

const FreeShippingBar = (props) => {
    const classes = useStyles(props)
    const {totalPrice} = useShoppingCart();

    const [t] = useTranslation();

    let text = t('Free delivery!');
    if (totalPrice <= 0) {
        text = t('Free delivery when you spend over %s', {
            postProcess: 'sprintf',
            sprintf: [formatCurrency(props.threshold)]
        })
    } else if (totalPrice < props.threshold) {
        text = t('Shop products for %s more and get free delivery!', {
            postProcess: 'sprintf',
            sprintf: [formatCurrency(props.threshold - totalPrice)]
        })
    }


    return <div className={classes.freeShipping}
                disableGutters={props.disableGutters}>
        {text}
    </div>
}

const Menu = ({menuOpen, onClose}) => {
    const [expandedItems, setExpandedItems] = useState({})
    const classes = useStyles();

    const toggleExpandedItem = (e, id) => {
        e.preventDefault();
        e.stopPropagation();

        setExpandedItems((expandedItems) => {
            let newExpandedItems = {...expandedItems}
            if (!newExpandedItems[id]) {
                newExpandedItems[id] = true;
            } else {
                delete newExpandedItems[id];
            }
            return newExpandedItems;
        })
    }

    console.log('Menu', window.EF_MENU);

    return (
        <Drawer open={menuOpen} onClose={onClose} className={classes.mainMenu}>
            <List>
                {window.EF_MENU.map((item, index) => {
                    const isActive = !!expandedItems[item.id];
                    const activeClass = isActive ? 'menu-active' : '';

                    const component = item.m ? Link : 'a';

                    return (
                        <React.Fragment key={item.id}>
                            <ListItem button component={component}
                                      href={item.url} to={item.url}
                                      className={`${classes.menuTopLevel} ${activeClass}`}
                                      onClick={onClose}>
                                <ListItemText primary={item.title}/>
                                {item.children && item.children.length > 0 &&
                                    <IconButton
                                        onClick={e => toggleExpandedItem(e, item.id)}>
                                        {isActive ? <Icon>expand_less</Icon> :
                                            <Icon>expand_more</Icon>}
                                    </IconButton>
                                }
                            </ListItem>
                            {isActive && item.children.map(item => {
                                const withChildrenClass = item.children && item.children.length > 0 ? 'menu-item-with-children' : '';
                                const component = item.m ? Link : 'a';
                                return <React.Fragment key={item.id}>
                                    <ListItem button key={item.id}
                                              component={component}
                                              href={item.url} to={item.url}
                                              onClick={onClose}
                                              className={`${classes.menuLevelOne} ${activeClass} ${withChildrenClass}`}>
                                        <ListItemText primary={item.title}/>
                                    </ListItem>
                                    {item.children && item.children.map(item => {
                                        console.log('Link item', item);
                                        const component = item.m ? Link : 'a';
                                        return <>
                                            <ListItem key={item.id} button
                                                      component={component}
                                                      href={item.url}
                                                      to={item.url}
                                                      onClick={onClose}
                                                      className={`${classes.menuLevelTwo} ${activeClass}`}>
                                                <ListItemText
                                                    primary={item.title}/>
                                            </ListItem>
                                        </>
                                    })}
                                </React.Fragment>
                            })}
                        </React.Fragment>
                    )
                })}
            </List>
        </Drawer>
    )
}

const ShoppingCart = ({items}) => {
    const classes = useStyles();
    return <IconButton
        edge="start"
        className={classes.menuButton}
        color="primary"
        aria-label="open drawer"
        component={Link}
        to={getNavigationUrl('SHOPPING_CART')}
    >
        <ShoppingCartIcon/>
        {items.length > 0 &&
            <div className={classes.cartItems}>{items.length}</div>}
    </IconButton>

}